import { BoxProps } from '@jfs/ui-new'

const shadowStyle = {
  shadowOffset: { width: 1, height: 1 },
  shadowRadius: 3,
  shadowColor: '#0000001F',
  borderRadius: 8,
  borderWidth: 1,
  borderColor: '#00000014',
  zIndex: 10,
}

const styles = {
  container: {
    ...shadowStyle,
    marginTop: 16,
    padding: 16,
    backgroundColor: 'WHITE',
    justifyContent: 'space-between',
  } as BoxProps,
  kycContainer: {
    ...shadowStyle,
    marginTop: 16,
    padding: 16,
    backgroundColor: 'WHITE',
    justifyContent: 'space-between',
    alignItems: 'center',
  } as BoxProps,
  separator: {
    backgroundColor: 'VERY_LIGHT_GREY',
    height: 1,
  } as BoxProps,
}

export { styles }
